<template>
  <div v-if="isOpen" :id="alertId" class="alert">
    <div :class="['dialog', size]">
      <div class="dialog-content">
        <slot name="content"></slot>
      </div>
      <div class="dialog-footer">
        <slot name="buttons"></slot>
      </div>
    </div>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "AlertPopup",
  props: {
    alertId: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
  },

  setup(props, { emit }) {
    const isOpen = ref(false);

    const openPopup = () => {
      isOpen.value = true;
    };

    const closePopup = () => {
      isOpen.value = false;
    };

    const handleConfirm = () => {
      emit("confirm");
      closePopup();
    };

    return {
      isOpen,
      openPopup,
      closePopup,
      handleConfirm,
    };
  },
};
</script>
